export default "__VITE_ASSET__DyOtPfiq__"